module.exports = __webpack_public_path__ + "assets/on-parking.b8afb43e.svg";